'use es6';

import MABEndTest from '../models/MABEndTest';
import { REQUESTED_MAB_END_EXPERIMENT, REQUESTED_MAB_END_EXPERIMENT_FAILED, REQUESTED_MAB_END_EXPERIMENT_SUCCEEDED } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new MABEndTest(), action) => {
  switch (action.type) {
    case REQUESTED_MAB_END_EXPERIMENT:
      return state.set('status', RequestStatus.PENDING);
    case REQUESTED_MAB_END_EXPERIMENT_FAILED:
      return state.set('status', RequestStatus.FAILED);
    case REQUESTED_MAB_END_EXPERIMENT_SUCCEEDED:
      return action.payload.mabEndTest;
    default:
      return state;
  }
});